
import { Component, Vue } from "vue-property-decorator";
import UiStep from "@/components/Main/Ui/UiStep.vue";
@Component({
    components: {
        UiStep,
    },
})
export default class ClientBenefits extends Vue {
    public handleBecomeResident() {
        this.$emit('become-resident');
    }
    public handleClientsChat() {
       console.log('go to chat')
    }
}
